module.exports = __webpack_public_path__ + "static/img/HLlogo2.7ff7073.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HLlogo2.jpg
// module id = D8kR
// module chunks = 54